export default __webpack_public_path__ + "static/media/call.a542847e.svg";